<template>
<div>
  <span class="step-message">{{ step.message }}</span>
  <span class="step-message">
    <strong v-if="step.todo"
            :class="[step.todo && step.todo === 'ON' ? 'mode-on' : step.todo && step.todo === 'OFF' ? 'mode-off' : 'mode-others']">
      {{step.todo }}
    </strong>
  </span>
</div>
</template>

<script>
export default {
  name: "StepText",
  props: ['step']
}
</script>

<style scoped lang="less">

.mode-on, .mode-off, .mode-others {

}

.mode-on {
  color: darkturquoise;
}

.mode-off {
  color: orangered;
}
.step-message {
  font-size: 20px;
  display: block;
  text-align: left;

  /* Small only */
  @media screen and (max-width: 599px) {
      font-size: 15px;
  }

  /* Medium only */
  @media screen and (min-width: 600px) and (max-width: 1264px) {
      font-size: 18px;
  }
}


</style>